"use strict";

define('config/moment',['require','exports','module','underscore','appkit/configurator','moment','language/support/supplemental.moment.locales','moment-tz'],function (require, exports, module) {
  var _ = require('underscore');
  var Configurator = require('appkit/configurator');
  var moment = require('moment');
  var SUPPLEMENTAL_MOMENT_LOCALES = require('language/support/supplemental.moment.locales');
  require('moment-tz');
  var MomentConfigurator = Configurator.extend({
    EN_LONG_DATE_FORMAT: {
      longDateFormat: {
        LT: "h:mm A",
        LTS: "h:mm:ss A",
        L: 'MM-DD-YYYY',
        LS: 'DD-YYYY',
        LL: "MMMM Do YYYY",
        LLL: "MMMM Do YYYY LT",
        LLLL: "dddd, MMMM Do YYYY LT"
      }
    },
    setSupplementalMomentLocales: function setSupplementalMomentLocales() {
      var localeKeys = _.keys(SUPPLEMENTAL_MOMENT_LOCALES);
      localeKeys.forEach(function (localeKey) {
        moment.defineLocale(localeKey, SUPPLEMENTAL_MOMENT_LOCALES[localeKey]);
      });
    },
    setMomentLocale: function setMomentLocale() {
      var browserLocale = navigator.language.toLowerCase();
      if (browserLocale === 'en-us' || browserLocale === 'en') {
        moment.locale('en', this.EN_LONG_DATE_FORMAT);
      } else {
        moment.locale(browserLocale);
      }
    },
    onBeforeConfigure: function onBeforeConfigure() {
      this.setSupplementalMomentLocales();
      this.setMomentLocale();
    }
  });
  module.exports = MomentConfigurator;
});

